import { default as HomeYestdayPoints } from '@/containers/home/Dialog/YestdayPoints';
import { justFormatNumber } from '@web3/base-utils';
import { useProjectData } from '@/containers/aidol/hooks';

interface Props {
  show: boolean;
  onClose: () => void;
}

export const YestdayPoints = (props: Props) => {
  const { show, onClose } = props;
  const { projectData } = useProjectData();
  return (
    <HomeYestdayPoints
      visible={show}
      totalPoints={justFormatNumber(projectData.point)}
      yesterdayRank={justFormatNumber(projectData.preRank)}
      yesterdayIncrease={justFormatNumber(projectData.rankChange)}
      onClose={onClose}
      queryType={1}
    />
  );
};
